import React from 'react';
import type { FC } from 'react';
import 'antd/dist/reset.css';
import './App.css';

import { AppRouter } from './routes/AppRouter';

import { IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { appInsightsReactPlugin } from './services/ApplicationInsightsService';

import { AuthorizationProvider } from './context/AuthorizationContext';

type AppProps = {
    pca: IPublicClientApplication;
};

const App: FC<AppProps> = ({ pca }) => {
    return (
        <AuthorizationProvider>
            <MsalProvider instance={pca}>
                <AppInsightsContext.Provider value={appInsightsReactPlugin}>
                    <AppRouter />
                </AppInsightsContext.Provider>
            </MsalProvider>
        </AuthorizationProvider>
    );
};

export default App;
